import React from 'react';
import { Box, TextButton } from '@zillow/constellation-10';

export type BillingViewAll = {
  onClick: () => void;
};

const BillingViewAll = ({ onClick }: BillingViewAll) => (
  <Box css={{ paddingBlock: 'lg', textAlign: 'center' }}>
    <TextButton onClick={onClick}>View All</TextButton>
  </Box>
);

export default BillingViewAll;
